export const MODAL_TYPE_DELETE_POST = 'delete-post';
